import React from 'react';

const SupportPage = () => {
  return (
    <div className="contact-page">
      <section className="contact-section">
        <div className="container">
          <div className="section-header">
            <h1 className="section-title">¿Necesitas asistencia o tienes alguna pregunta para el equipo GesOps?</h1>
            <p className="section-description">
              Comunícate con nosotros a través de nuestros canales oficiales. Estamos aquí para ayudarte en temas relacionados con soporte,
              información de servicios, registro en el directorio o dudas administrativas.
            </p>
          </div>

          <div className="membership-cta" style={{ marginTop: 24 }}>
            <div className="cta-content">
              <h3 className="cta-title">Opciones de contacto</h3>
              <div className="cta-buttons" style={{ flexWrap: 'wrap' }}>
                <button className="btn btn-secondary" type="button" disabled>
                  Solicitar información sobre el Directorio (próximamente)
                </button>
                <a
                  className="btn btn-primary"
                  href="https://wa.me/18049608133?text=Hola%2C+quisiera+hablar+con+un+asesor+de+GesOps"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Hablar con un asesor por WhatsApp
                </a>
              </div>
              <p className="section-description" style={{ marginTop: 12 }}>
                Al hacer clic, podrás dejarnos tus datos para que un asesor te contacte y responda todas tus preguntas.
              </p>

              <div style={{ marginTop: 18 }}>
                <h4>Correos oficiales</h4>
                <p>
                  <a href="mailto:contacto@gesops.com">contacto@gesops.com</a>
                </p>
                <p>
                  <a href="mailto:gesopsllc@gmail.com">gesopsllc@gmail.com</a>
                </p>
                <p className="section-description">
                  Escríbenos si necesitas ayuda con temas administrativos, soporte técnico o verificación de perfiles.
                </p>
              </div>

              <div className="membership-disclaimer" style={{ marginTop: 18 }}>
                <div className="disclaimer-box">
                  <div className="disclaimer-content">
                    <p>
                      <strong>Nota importante:</strong> GesOps no intermedia entre usuarios y empresas. Si deseas contratar un servicio, debes
                      contactar directamente al profesional a través de su perfil en el directorio. En caso de no responder el profesional,
                      déjanos un mensaje para brindar apoyo.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SupportPage;
